import { Component } from "react";
import Unknown from "./Unknown";
import { logShape, withLog } from "../../context";

type OwnProps = {
  log?: logShape;
  isFullPage?: boolean;
};

type State = $TSFixMe;

const defaultProps: Partial<OwnProps> = {
  isFullPage: false,
};

type Props = OwnProps & typeof defaultProps;

class ErrorBoundary extends Component<Props, State> {
  static readonly defaultProps = defaultProps;

  isFullPage: $TSFixMe;

  log: $TSFixMe;

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
    this.log = props.log;
    this.isFullPage = props.isFullPage;
  }

  // eslint-disable-next-line no-unused-vars
  componentDidCatch(error: $TSFixMe) {
    this.setState({ hasError: true });
    this.log?.error("ErrorBoundary", error);
  }

  render() {
    if (this.state.hasError) {
      // @ts-expect-error TS(2322) FIXME: Type '{ isFullPage: any; }' is not assignable to t... Remove this comment to see the full error message
      return <Unknown isFullPage={this.isFullPage} />;
    }
    return (this.props as $TSFixMe).children;
  }
}

export default withLog(ErrorBoundary);
